/**
 * 清理文本内容，移除 HTML 标签并限制长度
 * @param {string} text - 原始文本
 * @param {number} maxLength - 最大长度
 * @returns {string} 清理后的文本
 */
function cleanText(text, maxLength = 200) {
  if (!text) return '';
  // 移除 HTML 标签
  const cleaned = text.replace(/<[^>]*>/g, '').trim();
  // 限制长度
  return cleaned.length > maxLength ? cleaned.substring(0, maxLength) + '...' : cleaned;
}

/**
 * 更新页面的 Open Graph 和 SEO meta 标签
 * @param {Object} options - Meta 标签配置
 * @param {string} options.title - 页面标题
 * @param {string} options.description - 页面描述
 * @param {string} options.image - 图片 URL
 * @param {string} options.url - 页面 URL（可选，默认使用当前 URL）
 * @param {string} options.type - Open Graph 类型（默认 'article'）
 */
export function updateMetaTags({ title, description, image, url, type = 'article' }) {
  // 获取基础 URL
  const baseUrl = window.location.origin;
  const currentUrl = url || window.location.href;
  
  // 确保图片 URL 是完整的绝对 URL
  let imageUrl = image || '';
  if (imageUrl) {
    // 如果图片 URL 是相对路径，转换为绝对路径
    if (imageUrl.startsWith('/')) {
      imageUrl = `${baseUrl}${imageUrl}`;
    } else if (!imageUrl.startsWith('http://') && !imageUrl.startsWith('https://')) {
      // 如果既不是绝对路径也不是以 / 开头，添加基础 URL
      imageUrl = `${baseUrl}/${imageUrl}`;
    }
  } else {
    // 如果没有提供图片，使用默认 logo
    imageUrl = `${baseUrl}/logo.png`;
  }

  // 清理文本内容
  const cleanTitle = cleanText(title, 60);
  const cleanDescription = cleanText(description, 200);
  
  // Meta 标签配置
  const metaTags = [
    // Open Graph 标签
    { property: 'og:title', content: cleanTitle },
    { property: 'og:description', content: cleanDescription },
    { property: 'og:image', content: imageUrl },
    { property: 'og:url', content: currentUrl },
    { property: 'og:type', content: type },
    { property: 'og:site_name', content: 'Xigfor' },
    
    // Twitter Card 标签（可选，但推荐）
    { name: 'twitter:card', content: 'summary_large_image' },
    { name: 'twitter:title', content: cleanTitle },
    { name: 'twitter:description', content: cleanDescription },
    { name: 'twitter:image', content: imageUrl },
    
    // 标准 meta 标签
    { name: 'description', content: cleanDescription }
  ];

  // 更新或创建 meta 标签
  metaTags.forEach(tag => {
    let element;
    
    if (tag.property) {
      // Open Graph 标签使用 property 属性
      element = document.querySelector(`meta[property="${tag.property}"]`);
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute('property', tag.property);
        document.head.appendChild(element);
      }
      element.setAttribute('content', tag.content || '');
    } else if (tag.name) {
      // 标准 meta 标签使用 name 属性
      element = document.querySelector(`meta[name="${tag.name}"]`);
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute('name', tag.name);
        document.head.appendChild(element);
      }
      element.setAttribute('content', tag.content || '');
    }
  });

  // 更新页面标题
  if (cleanTitle) {
    document.title = cleanTitle;
  }
}

/**
 * 清除动态添加的 meta 标签（可选，用于页面切换时清理）
 */
export function clearMetaTags() {
  const ogTags = document.querySelectorAll('meta[property^="og:"]');
  const twitterTags = document.querySelectorAll('meta[name^="twitter:"]');
  
  ogTags.forEach(tag => tag.remove());
  twitterTags.forEach(tag => tag.remove());
}

